import { offlineInit } from '@eppo/js-client-sdk'
import { EppoConfiguration } from '../../types'
import { logAssignment } from '../trackExperiment/trackExperiment'
import { filterBotFriendlyAllocations } from '../../utils/filter-bot-friendly-allocations/filter-bot-friendly-allocations'

type CreateEppoClient = {
  flagsConfiguration: EppoConfiguration | null
  isBot?: boolean
}

let cachedEppoConfiguration: EppoConfiguration | null = null

export const createEppoClient = ({
  flagsConfiguration,
  isBot = false,
}: CreateEppoClient) => {
  if (flagsConfiguration) {
    cachedEppoConfiguration = flagsConfiguration
  }

  if (!cachedEppoConfiguration) return null

  if (isBot) {
    cachedEppoConfiguration = filterBotFriendlyAllocations(
      cachedEppoConfiguration,
    )
  }

  return offlineInit({
    flagsConfiguration: cachedEppoConfiguration,
    isObfuscated: false,
    assignmentLogger: { logAssignment },
  })
}
